import VMoney from 'v-money';
import legal from '../static/json/132724.json';

export default {
  directives: { VMoney },
  data() {
    return {
      data_counter: 1,
      //don't escape your regex. Just store it as is and it will work <3
      //this one will get rid of anything that isn't a "." to unformat the nums
      re: /[^\d.-]/g,
      legal,
      data: null,
      config: {
        // the configuration for the v-money directive that formats money pretty
        moneyConfig: {
          // The character used to show the decimal place.
          decimal: '',
          // The character used to separate numbers in groups of three.
          thousands: ',',
          // The currency name or symbol followed by a space.
          prefix: '$',
          // The suffix (If a suffix is used by the target currency.)
          suffix: '',
          // Level of decimal precision. REQUIRED
          precision: 0,
          // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
          masked: false
        },
        percentConfig:{
          // The character used to show the decimal place.
          decimal: '.',
          // The character used to separate numbers in groups of three.
          thousands: '',
          // The currency name or symbol followed by a space.
          prefix: '',
          // The suffix (If a suffix is used by the target currency.)
          suffix: '%',
          // Level of decimal precision. REQUIRED
          precision: 0,
          // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
          masked: false
        },
        multipleTimesConfig:{
          // The character used to show the decimal place.
          decimal: '.',
          // The character used to separate numbers in groups of three.
          thousands: ',',
          // The currency name or symbol followed by a space.
          prefix: '',
          // The suffix (If a suffix is used by the target currency.)
          suffix: 'X',
          // Level of decimal precision. REQUIRED
          precision: 0,
          // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
          masked: false
        },
        wholeNumConfig:{
          // The character used to show the decimal place.
          decimal: '',
          // The character used to separate numbers in groups of three.
          thousands: ',',
          // The currency name or symbol followed by a space.
          prefix: '',
          // The suffix (If a suffix is used by the target currency.)
          suffix: '',
          // Level of decimal precision. REQUIRED
          precision: 0,
          // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
          masked: false
        }
      }
    } // so we can preserve the initial state
  },

  created() {
    this.data = this.initialState();
  },

  methods: {
    reset_to_default: function(event){
      if(event){
        event.preventDefault();
      }
      // we do not want to lose our dynamic legal state
      let counter_preserve = this.data_counter;
      let legal_preserve = this.legal;
      this.data = this.initialState();
      this.legal = legal_preserve;
      this.data_counter = counter_preserve++;
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixin.js